<template>
  <div class="job-requirement">
    <h4>{{ titleLabel }}</h4>
    <div class="jd-section__items">
      <job-requirement-item
        v-for="(item, i) in items"
        :key="`JobRequirement${type}Item${i}`"
        class="jd-section__item jd-section__item--sm"
        :name="item"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
import JobRequirementItem from './jobRequirementItem'

export default {
  components: {
    'job-requirement-item': JobRequirementItem,
  },
  computed: {
    titleLabel() {
      return this.$t(`jobDetail['${this.type}']`)
    },
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    type: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
@screen desktop {
  .jd-section__items {
    @apply flex flex-wrap;
  }
  /* 2 items per row */
  .jd-section__items .jd-section__item {
    @apply w-1/2 pr-4;
  }
  /* 2nd item also doesn't need top margin */
  .jd-section__items .jd-section__item.jd-section__item--sm:nth-child(2) {
    @apply mt-0;
  }
}
</style>
